import React, { useEffect, useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import "./keymodal.css";
import { Save, SquarePen } from "lucide-react";
import apiServiceHandler from "../../service/apiService";
import toastr from "toastr";

const KeyModal = ({ isOpen, onClose, keyData, selectedDate }) => {
  const [editKey, setEditKey] = useState(false);
  
  const textAreaRef = useRef();
  const [keyInfo, setKeyInfo] = useState("");
  const [keysInfo, setKeysInfo] = useState({});
  const [initialKeysInfo, setInitialKeysInfo] = useState({});
  const isSunday = selectedDate.getDay() === 0

  const isDateOlderThanToday =
    new Date(selectedDate) < new Date().setHours(0, 0, 0, 0);

  useEffect(() => {
    if (editKey) {
      textAreaRef.current?.focus();
    }
  }, [editKey]);

  const handleEditKey = () => {
    setEditKey(!editKey);
  };

  useEffect(() => {
    const fetchData = async () => {
      setKeysInfo({});
      const payload = {
        date: selectedDate,
      };
      try {
        const res = await apiServiceHandler("POST", "api/key4/fetch", payload);
        if (res.status && res.data?.length) {
          const fetchedKeys = res.data;
          if (isSunday) {
            if (selectedDate.toISOString().split("T")[0] === fetchedKeys[0].date.split("T")[0]) {
              setKeysInfo(fetchedKeys);
              setInitialKeysInfo(fetchedKeys);
              setKeyInfo(
                keyData.name == "KEY 1"
                  ? fetchedKeys[0].key1
                  : keyData.name == "KEY 2"
                  ? fetchedKeys[0].key2
                  : keyData.name == "KEY 3"
                  ? fetchedKeys[0].key3
                  : fetchedKeys[0].key4
              );
            } else {
              setKeysInfo(fetchedKeys);
              setKeyInfo(null);
            }
          } else {
            setKeysInfo(fetchedKeys);
            setInitialKeysInfo(fetchedKeys);
            setKeyInfo(
              keyData.name == "KEY 1"
                ? fetchedKeys[0].key1
                : keyData.name == "KEY 2"
                ? fetchedKeys[0].key2
                : keyData.name == "KEY 3"
                ? fetchedKeys[0].key3
                : fetchedKeys[0].key4
            );
          }
        }
      } catch (error) {
        console.log("Failed to fetch data");
      }
    };

    fetchData();
  }, [isOpen, keyData]);

  const sendKey4 = async () => {
    const updatedKeyInfo = {
      key1: keyData.name == "KEY 1" ? keyInfo :  keysInfo?.length ? keysInfo[0].key1 : '',
      key2: keyData.name == "KEY 2" ? keyInfo :  keysInfo?.length ? keysInfo[0].key2 : '',
      key3: keyData.name == "KEY 3" ? keyInfo :  keysInfo?.length ? keysInfo[0].key3 : '',
      key4: keyData.name == "KEY 4" ? keyInfo :  keysInfo?.length ? keysInfo[0].key4 : '',
    };

    const keysFilled = [
      updatedKeyInfo.key1,
      updatedKeyInfo.key2,
      updatedKeyInfo.key3,
      updatedKeyInfo.key4,
    ].filter((key) => key?.length > 0).length;

    const newProgress = (keysFilled / 4) * 100;

    const payload = {
      ...updatedKeyInfo,
      progress: newProgress,
      date: selectedDate,
    };

    const isSunday = new Date().getDay() === 0;

    if (!isSunday) {
        payload._id = keysInfo?.length ? keysInfo[0]._id : null;
      }

    const apiEndpoint = isSunday ? "api/key4" : "api/key4/update";

    try {
      const res = await apiServiceHandler("POST", apiEndpoint, payload);
      if (res.status) {
        toastr.success(res.message);
        setEditKey(false);
      }
    } catch (error) {
      console.log("Failed to update key");
    } finally {
      setTimeout(() => {
        onClose()
      }, 1500)
    }
  };

  return (
    <Modal
      show={isOpen}
      onHide={onClose}
      centered
    >
      <Modal.Header closeButton style={{ borderBottom: "none" }}>
        <Modal.Title>{keyData?.name}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="edit-key">
          <textarea
            className="key-input"
            ref={textAreaRef}
            placeholder={!editKey ? `Add your new ${keyData?.name} task for this next week` : ""}
            // placeholder={!editKey ?  : ""}
            readOnly={!editKey}
            style={editKey ? { background: "#f3f4f6" } : {}}
            value={keyInfo}
            onChange={(e) => setKeyInfo(e.target.value)}
            onClick={() => {
              if (!editKey && !isDateOlderThanToday) {
                setEditKey(true);
              }
            }}
          />
          {!isDateOlderThanToday && (
            <div
              className="square-key-pen"
              onClick={!editKey ? handleEditKey : sendKey4}
            >
              {!editKey ? <SquarePen size={16} /> : <Save size={16} />}
            </div>
          )}
        </div>
      </Modal.Body>
      <Modal.Footer style={{ borderTop: "none", paddingTop: "1rem" }} />
    </Modal>
  );
};

export default KeyModal;
